export const money = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  const sign = v < 0 ? "-" : "";
  return `${sign}$${Math.abs(v).toFixed(2)}`;
};

export const moneySigned = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  if (v >= 0) return `$${v.toFixed(2)}`;
  return `-$${Math.abs(v).toFixed(2)}`;
};

export const dateShort = (d) => {
  if (!d) return "—";
  // try parse as ISO
  const t = new Date(d);
  if (!Number.isNaN(t.getTime())) {
    return t.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }
  return String(d);
};

export const statusLabel = {
  matched: "GOOD",
  overcharge: "Overcharge",
  missing_from_cms: "Missing from CMS",
  missing_from_ups: "Not yet billed",
  prp_pending: "PRP pending",
};

export const NOTE_OPTIONS = [
  "Overcharged",
  "Missing Transaction",
  "Missing Invoice",
  "Awaiting PRP Payment",
  "Disputed with UPS",
  "To Be Disputed",
  "Manual Check Needed",
];
